import { memo, FC } from 'react';

import resets from '../../_resets.module.css';
import classes from './SectionTitle_sub.module.scss';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
  text?:string;
}

export const SectionTitle_sub: FC<Props> = memo(function SectionTitle_sub(props) {
  return (
    <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.sectionTitle_sub}`}>{props.text || 'SUB-TITLE'}</div>
  );
});


